import React, { Fragment, useMemo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import SearchItem from '../SearchItem';

import { useSearch } from '../../hooks/search';

import { flightTypesList } from '../../common/types';

const SearchGroup: React.FC = () => {
  const { isMultiCityFlight, flightType, setIsMultiCityFlight } = useSearch();
  const { t } = useTranslation('flightSearch');

  const searchItemsToShow = useMemo(
    () => Array.from(Array(isMultiCityFlight ? 2 : 1).keys()),
    [isMultiCityFlight]
  );

  useEffect(() => {
    if (flightType === flightTypesList.MULTI_CITY) {
      setIsMultiCityFlight(true);
      return;
    }
    setIsMultiCityFlight(false);
  }, [flightType, setIsMultiCityFlight]);

  return (
    <>
      {searchItemsToShow.map((item) => (
        <Fragment key={item}>
          {isMultiCityFlight && (
            <span>
              {t(item === 0 ? 'firstDestination' : 'secondDestination')}
            </span>
          )}
          <SearchItem type={item === 0 ? 'firstLeg' : 'secondLeg'} />
        </Fragment>
      ))}
    </>
  );
};

export default SearchGroup;
